import tw from 'twin.macro';
import {
  styled
} from 'styled-components';

export const ListContainer = styled.div`
  ${tw`flex flex-col h-full`}
`;
